/* eslint-disable */
import {
    SET_CURRENT_USER, LOGIN, LOGOUT, VALIDATE_USER, VERIFY_2FA, SET_CURRENT_USER_EMAIL,
    UPDATE_LOADING_STATUS, SET_LOADING_STATUS,
    SET_PRIVACY_CONSENT, SET_PRIVACY_CONSENT_FIELD,
    UPDATE_TOAST_NOTIFICATION, SET_TOAST_NOTIFICATION,  SET_TOAST_NOTIFICATION_FIELD, SHOW_TOAST_NOTIFICATION,   
    //UPDATE_PRODUCT_REGISTRATION, SAVE_PRODUCT_REGISTRATION, 
} from "@/state/actions-mutations-type";
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';

export const authMethods = mapActions({
    LOGIN: "auth/" + LOGIN,
    LOGOUT: "auth/" + LOGOUT,
    VERIFY_2FA: "auth/" + VERIFY_2FA
});

export const authMutations = mapActions({
    SET_CURRENT_USER: "auth/" + SET_CURRENT_USER,
    SET_CURRENT_USER_EMAIL: "auth/" + SET_CURRENT_USER_EMAIL,
});

export const authComputed = {
    ...mapState('auth', {
        currentUser: (state) => state.currentUser,
        currentUserEmail: (state) => state.currentUserEmail,
    }),
    ...mapGetters({
        loggedIn: "auth/loggedIn",
        isAuthenticated: "auth/isAuthenticated",
        currentUser: "auth/currentUser"
    })
};


// export const productMethods = mapActions({
//     productReset: "product/reset",
// });
// export const productComputed = {
//     ...mapGetters({
//         product: "product/product"
//     })
// };
// export const productMutations = mapMutations({
//     SET_PRODUCT: "product/" + SET_PRODUCT,
//     SET_PRODUCT_FIELD: "product/" + SET_PRODUCT_FIELD
// });


// export const productRegistrationMethods = mapActions({
//     productRegistrationReset: "productRegistration/reset",
// });
// export const productRegistrationComputed = {
//     ...mapGetters({
//         productRegistration: "productRegistration/productRegistration"
//     })
// };
// export const productRegistrationMutations = mapMutations({
//     SET_PRODUCT_REGISTRATION: "productRegistration/" + SET_PRODUCT_REGISTRATION,
//     SET_PRODUCT_REGISTRATION_FIELD: "productRegistration/" + SET_PRODUCT_REGISTRATION_FIELD
// });

//loading
export const loadingComputed = {
    ...mapGetters({
        loading: "loader/isLoading"
    })
};

export const loadingMethods = mapActions({
    UPDATE_LOADING_STATUS: "loader/" + UPDATE_LOADING_STATUS
});

export const loadingMutations = mapMutations({
    SET_LOADING_STATUS: "loader/" + SET_LOADING_STATUS,
});

//toast notification
export const toastNotificationComputed = {
    ...mapGetters({
        toastNotification: "toastNotification/toastNotification"
    })
};

export const toastNotificationMethods = mapActions({
    UPDATE_TOAST_NOTIFICATION: "toastNotification/" + UPDATE_TOAST_NOTIFICATION,
    SET_TOAST_NOTIFICATION_FIELD: "toastNotification/" + SET_TOAST_NOTIFICATION_FIELD,
    SHOW_TOAST_NOTIFICATION: "toastNotification/" + SHOW_TOAST_NOTIFICATION    
});

export const toastNotificationMutations = mapMutations({
    SET_TOAST_NOTIFICATION: "toastNotification/" + SET_TOAST_NOTIFICATION
});



//cookie policy
export const cookiePolicyComputed = {
    ...mapGetters({
        privacyConsent: "cookies/privacyConsent"
    })
};
export const cookiePolicyMutations = mapMutations({
    SET_PRIVACY_CONSENT: "cookies/" + SET_PRIVACY_CONSENT,
    SET_PRIVACY_CONSENT_FIELD: "cookies/" + SET_PRIVACY_CONSENT_FIELD,
});


